<template>
  <div>
    <botton-bar/>
    <div class="content">
      <div class="container">
        <loading v-if="load" :fullscrean="true" text="Buscando calendário"/>
        <div style="max-width: 600px" v-else>
          <div class="card card-filtro mb-3">
            <a href="javascript:" class="bg-primary text-white p-3 d-flex justify-content-between align-items-center text-decoration-none"
               @click="showFiltros = !showFiltros">
              <h6 class="text-center mb-0">{{ quantidadeFiltrosAtivos ? `Filtros ativos (${quantidadeFiltrosAtivos})` : 'Filtros' }}</h6>
              <i class="fa-solid" :class="showFiltros ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </a>
            <div style="padding: 10px 16px 16px" v-show="showFiltros">
              <div class="form-group mb-2">
                <label class="mb-0">Setor:</label>
                <select class="form-control" v-model="pesquisa.id_setor" @change="getReunioes()" :disabled="isLogged && user.id_setor">
                  <option value="" v-if="!isLogged || !user.id_setor">Todos os setores</option>
                  <option :value="s.id_setor" v-for="s in setoresDisponiveis" :key="s.id_setor">Setor - {{ s.nome_setor }}</option>
                </select>
              </div>
              <div class="form-group mb-2" v-if="isLogged">
                <label class="mb-0">Cidade:</label>
                <select class="form-control" v-model="pesquisa.id_cidade" @change="aplicarFiltroCidade()" :disabled="!cidades.length">
                  <option value="">Todas as cidades</option>
                  <option :value="c.id_cidade" v-for="c in cidades" :key="c.id_cidade">{{ c.nome_cidade }} - {{ c.sigla_estado }}</option>
                </select>
              </div>
              <div class="form-group mb-2">
                <label class="mb-0">Abrangência:</label>
                <select class="form-control" v-model="pesquisa.abrangencia" @change="aplicarFiltroCidade()">
                  <option value="">Todas</option>
                  <option value="regional">Regionais</option>
                  <option value="local">Locais</option>
                </select>
              </div>
              <div class="form-group mb-2">
                <label class="mb-1">Tipos de reunião:</label>
                <div class="tipos-reuniao-grid">
                  <button type="button" class="btn btn-sm"
                          :class="!pesquisa.tipos_reuniao.length ? 'btn-primary' : 'btn-outline-secondary'"
                          :aria-pressed="!pesquisa.tipos_reuniao.length" @click="limparTiposReuniao">
                    Todos
                  </button>
                  <button type="button" class="btn btn-sm" v-for="tipo in tiposReuniao" :key="tipo.valor"
                          :class="pesquisa.tipos_reuniao.includes(tipo.valor) ? 'btn-primary' : 'btn-outline-secondary'"
                          :aria-pressed="pesquisa.tipos_reuniao.includes(tipo.valor)" @click="alternarTipoReuniao(tipo.valor)">
                    {{ tipo.nome }}
                  </button>
                </div>
              </div>
              <div class="text-center mt-3">
                <a href="javascript:" class="small" @click="limparFiltros"><u>Limpar filtros</u></a>
              </div>
            </div>
          </div>
          <div v-show="!showFiltros">
            <calendario-categoria-pesquisa :categorias="$store.state.dados.categorias || []" :value="idCategoriaPesquisa"
                                           @selecionar="selecionarCategoria" @limpar="limparPesquisaCategoria"/>
          </div>
          <c-offline class="mt-3" v-if="offline"/>
          <div v-else>
            <div class="pt-3" id="listaReunioes" v-show="!isSearching">
              <v-date-picker locale="pt-BR" is-expanded :first-day-of-week="1" :attributes='attributes' :is-dark="resolvedTheme === 1"
                             ref="calendar" v-model="selectedDate"
                             @dayclick="toggleDia" @update:from-page="atualizarMesVisivel"/>
            </div>
            <div class="mt-3" v-if="selected" style="min-height: 40vh">
              <div class="alert alert-warning d-flex justify-content-between" v-if="isSearching">
                Pesquisa ativada
                <a href="javascript:" class="text-dark small" @click="limparPesquisaCategoria"><u>Limpar pesquisa</u></a>
              </div>
              <div class="mt-3 text-center py-4" v-if="!selected.length">
                {{ isSearching ? 'Nenhuma reuniões encontrada' : 'Não há reuniões neste dia' }}
              </div>
              <div class="mt-2" v-for="r in selected">
                <lista :nome="r.nome_reuniao" @go="openReuniao" :id="r.id_reuniao" icone="true">
                  <div>
                    <p class="m-0 text-muted" v-if="isSearching">
                      {{ r.data_reuniao | date }} - {{ r.hora_reuniao }} | {{`${r.nome_cidade} (${r.nome_localidade})`}}
                    </p>
                    <p class="m-0 text-muted" v-else>{{`Horário: ${r.hora_reuniao}`}} - {{`${r.nome_cidade} (${r.nome_localidade})`}}</p>
                  </div>
                </lista>
              </div>
            </div>
          </div>
        </div>

        <modal-reuniao ref="modal"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Lista from "../components/Lista";
  import Loading from "../components/Loading";
  import ModalReuniao from "@/components/ModalReuniao";
  import BottonBar from "@/components/BottonBar";
  import COffline from "@/components/COffline";
  import CalendarioCategoriaPesquisa from '@/components/CalendarioCategoriaPesquisa';

  export default {
    name: 'Calendario',
    components: {CalendarioCategoriaPesquisa, COffline, BottonBar, ModalReuniao, Loading, Lista},

    data() {
      const date = new Date();

      return {
        date,
        load: true,
        pesquisa: { id_setor: '', ano: '', id_cidade: '', abrangencia: '', tipos_reuniao: [] },
        tiposReuniao: [
          {valor: 1, nome: 'Reunião Ministerial'},
          {valor: 2, nome: 'Serviço Divino'},
          {valor: 3, nome: 'Reunião Musical'},
          {valor: 4, nome: 'Reunião Administrativa'},
          {valor: 5, nome: 'Reunião da Piedade'}
        ],
        cidades: [],
        calendarioBase: [],
        reunioesPorData: {},
        mesVisivel: null,
        paginaDestino: null,
        selected: null,
        selectedDate: null,
        attributes: null,
        offline: false,
        isSearching: false,
        showFiltros: false,
        idCategoriaPesquisa: null
      }
    },

    methods: {
      getDateKey(date) {
        if (!date) {
          return '';
        }

        if (typeof date === 'string') {
          return date;
        }

        const year = date.getFullYear();
        const month = (`0${date.getMonth() + 1}`).slice(-2);
        const day = (`0${date.getDate()}`).slice(-2);
        return `${year}-${month}-${day}`;
      },

      getMonthKey(date) {
        if (!date) {
          return '';
        }

        if (date.year && date.month) {
          const month = (`0${date.month}`).slice(-2);
          return `${date.year}-${month}`;
        }

        const value = typeof date === 'string' ? new Date(`${date}T00:00:00`) : date;
        const year = value.getFullYear();
        const month = (`0${value.getMonth() + 1}`).slice(-2);
        return `${year}-${month}`;
      },

      filtrarCalendario(dados) {
        return (dados || []).filter(r => {
          const flag = r.exibir_calendario;
          if (flag === undefined || flag === null || flag === '') {
            return true;
          }
          const flagStr = String(flag).trim().toLowerCase();
          const oculto = flag === false || flagStr === '0' || flagStr === 'false';

          if (!oculto) {
            return true;
          }

          if (!this.isLogged || !this.user.id_cidade) {
            return false;
          }

          return String(r.id_cidade) === String(this.user.id_cidade);
        });
      },

      normalizarCalendario(dados) {
        return this.filtrarCalendario(dados);
      },

      filtrarCidade(dados) {
        if (!this.pesquisa.id_cidade) {
          return dados;
        }

        return (dados || []).filter(r => String(r.id_cidade) === String(this.pesquisa.id_cidade));
      },

      filtrarTipoReuniao(dados) {
        if (!this.pesquisa.tipos_reuniao.length) {
          return dados || [];
        }

        return (dados || []).filter(r => this.pesquisa.tipos_reuniao.includes(+r.tipo_reuniao));
      },

      filtrarAbrangencia(dados) {
        if (!this.pesquisa.abrangencia) {
          return dados || [];
        }

        const categorias = this.$store.state.dados.categorias || [];
        return (dados || []).filter(reuniao => {
          const categoria = categorias.find(item => String(item.id_categoria) === String(reuniao.id_categoria));
          const isRegional = !!categoria && +categoria.is_regional === 1;
          return this.pesquisa.abrangencia === 'regional' ? isRegional : !isRegional;
        });
      },

      alternarTipoReuniao(tipo) {
        this.pesquisa.tipos_reuniao = this.pesquisa.tipos_reuniao.includes(tipo)
          ? this.pesquisa.tipos_reuniao.filter(valor => valor !== tipo)
          : [...this.pesquisa.tipos_reuniao, tipo];
        this.salvarFiltroTiposReuniao();
        this.aplicarFiltroCidade();
      },

      limparTiposReuniao() {
        this.pesquisa.tipos_reuniao = [];
        this.salvarFiltroTiposReuniao();
        this.aplicarFiltroCidade();
      },

      limparFiltros() {
        this.pesquisa.id_cidade = '';
        this.pesquisa.abrangencia = '';
        this.pesquisa.tipos_reuniao = [];
        this.salvarFiltroTiposReuniao();

        if (!this.isLogged || !this.user.id_setor) {
          this.pesquisa.id_setor = '';
        }

        this.getReunioes();
      },

      selecionarCategoria(categoria) {
        this.idCategoriaPesquisa = +categoria.id_categoria;

        const today = new Date().toJSON().slice(0, 10);
        const calendarioCidade = this.filtrarCidade(this.$store.state.calendario.datas || []);
        const calendarioTipo = this.filtrarTipoReuniao(calendarioCidade);
        const calendario = this.filtrarAbrangencia(calendarioTipo);
        this.selected = calendario.filter(reuniao =>
          +reuniao.id_categoria === this.idCategoriaPesquisa && reuniao.data_reuniao >= today
        );
        this.isSearching = true;
      },

      limparPesquisaCategoria() {
        this.idCategoriaPesquisa = null;
        this.selected = null;
        this.isSearching = false;
        this.getToday();
      },

      chaveFiltroTiposReuniao() {
        return `calendario_tipos_reuniao_${this.regionalId}`;
      },

      salvarFiltroTiposReuniao() {
        localStorage.setItem(this.chaveFiltroTiposReuniao(), JSON.stringify(this.pesquisa.tipos_reuniao));
      },

      restaurarFiltroTiposReuniao() {
        try {
          const salvo = JSON.parse(localStorage.getItem(this.chaveFiltroTiposReuniao()) || '[]');
          this.pesquisa.tipos_reuniao = Array.isArray(salvo)
            ? [...new Set(salvo.map(Number).filter(tipo => [1, 2, 3, 4, 5].includes(tipo)))]
            : [];
        } catch (e) {
          this.pesquisa.tipos_reuniao = [];
        }
      },

      atualizarCidades() {
        const mapa = {};
        (this.calendarioBase || []).forEach(r => {
          if (r.id_cidade && !mapa[r.id_cidade]) {
            mapa[r.id_cidade] = {
              id_cidade: r.id_cidade,
              nome_cidade: r.nome_cidade,
              sigla_estado: r.sigla_estado
            };
          }
        });

        this.cidades = Object.values(mapa)
          .sort((a, b) => (a.nome_cidade || '').localeCompare(b.nome_cidade || ''));
      },

      definirCidadePadrao() {
        if (this.pesquisa.id_cidade) {
          const selecionada = this.cidades.find(c => String(c.id_cidade) === String(this.pesquisa.id_cidade));
          if (!selecionada) {
            this.pesquisa.id_cidade = '';
          }
        }

        if (!this.isLogged || this.pesquisa.id_cidade || !this.user.id_cidade) {
          return;
        }

        const existe = this.cidades.find(c => String(c.id_cidade) === String(this.user.id_cidade));
        if (existe) {
          this.pesquisa.id_cidade = String(this.user.id_cidade);
        }
      },

      aplicarFiltroCidade() {
        const datasCidade = this.filtrarCidade(this.calendarioBase || []);
        const datasTipo = this.filtrarTipoReuniao(datasCidade);
        const datas = this.filtrarAbrangencia(datasTipo);
        const calendario = { datas: this.calendarioBase || [], ano: this.pesquisa.ano, id_setor: this.pesquisa.id_setor };
        this.$store.commit('setCalendario', calendario);
        this.isSearching = false;
        this.idCategoriaPesquisa = null;
        this.selected = null;
        this.preencherCalendario(datas);
      },

      getReunioes(opcoes = {}) {
        const manterMes = opcoes && opcoes.manterMes;
        if (manterMes) {
          this.paginaDestino = {ano: +opcoes.ano, mes: +opcoes.mes};
          this.selectedDate = new Date(+opcoes.ano, +opcoes.mes - 1, 1);
          this.mesVisivel = this.getMonthKey(this.selectedDate);
        } else {
          this.paginaDestino = null;
        }
        this.offline = false;
        this.load = true;
        this.showFiltros = false;
        this.selected = null;
        this.isSearching = false;
        this.idCategoriaPesquisa = null;

        if (!this.isLogged) {
          this.pesquisa.id_cidade = '';
        }

        if (this.isLogged && this.user.id_setor) {
          this.pesquisa.id_setor = String(this.user.id_setor);
        }

        if (this.pesquisa.id_setor) {
          localStorage.setItem('setor', this.pesquisa.id_setor);

        } else {
          localStorage.removeItem('setor');
        }

        const url = 'app/reunioes/' + this.regionalId;
        const cache = `${url}/${this.pesquisa.id_setor || 'all'}/${this.pesquisa.ano}`;
        const params = { id_setor: this.pesquisa.id_setor, ano: this.pesquisa.ano };

        if (this.isLogged && this.user.token) {
          params.token = this.user.token;
        }

        this.$http.get(url, { params })
          .then(response => {
            const datasBase = this.normalizarCalendario(response.data || []);
            this.calendarioBase = datasBase;
            this.atualizarCidades();
            this.definirCidadePadrao();
            this.aplicarFiltroCidade();

            const calendario = { datas: datasBase, ano: this.pesquisa.ano, id_setor: this.pesquisa.id_setor };
            localStorage.setItem(cache, JSON.stringify(calendario))

          }, res => {
            const data = localStorage.getItem(cache);

            if (data) {
              const calendario = JSON.parse(data);
              const datasBase = this.normalizarCalendario(calendario.datas || []);
              this.calendarioBase = datasBase;
              this.atualizarCidades();
              this.definirCidadePadrao();
              this.aplicarFiltroCidade();

            } else {
              this.offline = true;
            }

            this.load = false;
          });
      },

      toggleDia(date) {
        const key = this.getDateKey(date.date);
        this.selected = this.selectedDate ? (this.reunioesPorData[key] || []) : null;

        if (this.$helpers.isMobile()) {
          this.$nextTick(() => {
            const el = document.getElementById('listaReunioes');
            if (el) { el.scrollIntoView() }
          });
        }
      },

      preencherCalendario(datas) {
        const reunioesPorData = {};

        datas.forEach(d => {
          const key = d.data_reuniao;

          if (!reunioesPorData[key]) {
            reunioesPorData[key] = [];
          }

          reunioesPorData[key].push(d);
        });

        this.reunioesPorData = reunioesPorData;

        if (!this.mesVisivel) {
          this.mesVisivel = this.getMonthKey(this.selectedDate || this.date);
        }

        this.atualizarAtributosMes();
        this.$nextTick(() => {
          if (this.paginaDestino) {
            const destino = this.paginaDestino;
            const mes = (`0${destino.mes}`).slice(-2);
            const data = `${destino.ano}-${mes}-01`;
            this.selectedDate = new Date(destino.ano, destino.mes - 1, 1);
            this.mesVisivel = `${destino.ano}-${mes}`;
            this.selected = this.reunioesPorData[data] || [];
            this.paginaDestino = null;
            this.atualizarAtributosMes();
          } else {
            this.getToday();
          }
          this.load = false;
        });
      },

      atualizarAtributosMes() {
        const attr = [];
        const mesVisivel = this.mesVisivel || this.getMonthKey(this.selectedDate || this.date);

        Object.keys(this.reunioesPorData).forEach(key => {
          if (!key.startsWith(mesVisivel)) {
            return;
          }

          const date = key.split('-');
          attr.push({
            key,
            dot: true,
            highlight: false,
            dates: new Date(date[0], date[1] - 1, date[2])
          });
        });

        this.attributes = attr;
      },

      atualizarMesVisivel(page) {
        const nextMonth = this.getMonthKey(page);

        if (!nextMonth || nextMonth === this.mesVisivel) {
          return;
        }

        if (+page.year !== +this.pesquisa.ano) {
          this.pesquisa.ano = +page.year;
          this.getReunioes({manterMes: true, ano: page.year, mes: page.month});
          return;
        }

        this.mesVisivel = nextMonth;
        this.atualizarAtributosMes();
      },

      openReuniao(id) {
        this.$router.push('/calendario/' + id + '?regional=' + this.regionalId);
      },

      getToday() {
        let today;

        if (this.date.getFullYear() === this.pesquisa.ano) {
          this.selectedDate = this.date;
          let year = this.date.getFullYear();
          let month = ("0" + (this.date.getMonth() + 1)).slice(-2);
          let date = ("0" + this.date.getDate()).slice(-2);
          today = `${year}-${month}-${date}`;

        } else {
          this.selectedDate = new Date(this.pesquisa.ano, 0, 1);
          today = `${this.pesquisa.ano}-01-01`;
        }

        this.mesVisivel = this.getMonthKey(this.selectedDate);
        this.atualizarAtributosMes();
        this.selected = this.reunioesPorData[today] || [];
      },

    },

    mounted() {
      if (!this.regionalId) {
        return;
      }

      document.body.classList.remove("modal-open");
      this.restaurarFiltroTiposReuniao();
      const calendario = this.$store.state.calendario;
      const anoAtual = this.date.getFullYear();
      const setorUsuario = this.isLogged && this.user.id_setor ? String(this.user.id_setor) : null;
      this.pesquisa.id_setor = setorUsuario || localStorage.getItem('setor') || '';

      if (calendario.ano === anoAtual && calendario.id_setor == this.pesquisa.id_setor) {
        this.pesquisa.ano = calendario.ano;
        const datasBase = this.normalizarCalendario(calendario.datas || []);
        this.calendarioBase = datasBase;
        this.atualizarCidades();
        this.definirCidadePadrao();
        this.aplicarFiltroCidade();

      } else {
        this.pesquisa.ano = anoAtual;
        this.getReunioes();
      }

      const id = this.$route.params.id;

      if (id && !isNaN(parseInt(id))) {
        this.$emit('openModal', id);
      }
    },

    computed: {
      quantidadeFiltrosAtivos() {
        return this.pesquisa.tipos_reuniao.length +
          (this.pesquisa.id_setor ? 1 : 0) +
          (this.pesquisa.abrangencia ? 1 : 0);
      },

      user() {
        return this.$store.state.user;
      },

      isLogged() {
        return !!this.user.id_membro;
      },

      setores() {
        return this.$store.state.dados.setores
      },

      setoresDisponiveis() {
        if (this.isLogged && this.user.id_setor) {
          return (this.setores || []).filter(s => String(s.id_setor) === String(this.user.id_setor));
        }

        return this.setores;
      },

      regionalId() {
        return this.$store.state.id_regional;
      },

      theme() {
        return this.$store.state.theme;
      },

      resolvedTheme() {
        return this.$store.state.resolvedTheme;
      }
    },

    filters: {
      date(d) {
        const date = d ? d.split('-') : null;
        return date && date.length === 3 ? `${date[2]}/${date[1]}/${date[0]}` : '';
      }
    },

    watch: {
      selectedDate(val) {
        if (!val || this.isSearching) {
          return;
        }

        const nextMonth = this.getMonthKey(val);

        if (nextMonth !== this.mesVisivel) {
          this.mesVisivel = nextMonth;
          this.atualizarAtributosMes();
        }
      },

      $route(to, from) {
        if (to.name === 'ReuniaoHome' && to.params.id) {
          this.$emit('openModal', to.params.id);

        } else {
          this.$emit('closeModal');
        }
      }
    },
  }
</script>

<style>
  .content .container > div[style*="max-width: 600px"] {
    max-width: 600px !important;
    width: 100%;
  }

  .card-filtro {
    border-radius: 8px;
    overflow: hidden;
  }

  .card-filtro + div > .d-flex {
    display: flex;
    align-items: stretch;
    gap: 8px;
  }

  .card-filtro + div > .d-flex .form-control {
    flex: 1 1 auto;
    min-width: 0;
    margin-right: 0 !important;
  }

  .card-filtro + div > .d-flex .btn {
    flex: 0 0 auto;
  }

  .tipos-reuniao-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .tipos-reuniao-grid .btn {
    min-height: 38px;
    white-space: normal;
  }


  .vc-container {
    border-radius: 18px !important;
    overflow: hidden;
  }

  .vc-day {
    padding: 4px !important;
  }

  .vc-header {
    background: linear-gradient(135deg, var(--primary) 0%, var(--third) 100%);
    color: #fff;
    padding: 12px 12px 9px!important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    margin-bottom: 6px;
  }

  .vc-title {
    color: #fff !important;
    font-weight: 700;
    letter-spacing: 0.01em;
    line-height: 1;
    opacity: 1 !important;
  }

  .vc-arrow {
    color: #fff !important;
  }

  .vc-arrow:hover {
    color: #fff !important;
    background: none!important;
  }

  @media (min-width: 768px) {
    .content .container > div[style*="max-width: 600px"] {
      max-width: 720px !important;
    }
  }
</style>
